import { useState } from "react";
import { Card, CardBody, Col, Toast, ToastHeader } from "reactstrap";
import { dynamicImage } from "../../../utils";
import UniqueToastContent from "./common/UniqueToastContent";
import { UniqueToastTitle } from "../../../constants";
import { ColorsSchemeSubTitle } from "../../../data/bonusUi/Toasts";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import { Image } from "../../../coreComponents/Image";

const UniqueToast = () => {
  const [visible, setVisible] = useState(true);
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={UniqueToastTitle} span={ColorsSchemeSubTitle} />
        <CardBody className="toast-rtl">
          <Toast isOpen={visible} fade>
            <ToastHeader className="toast-img" toggle={() => setVisible(!visible)}>
              <Image className="rounded me-2" src={dynamicImage(`dashboard-8/profile.png`)} alt="profile" />
              <strong className="me-auto">{"Berlin Theme"}</strong>
            </ToastHeader>
            <UniqueToastContent visible={visible} setVisible={setVisible} />
          </Toast>
        </CardBody>
      </Card>
    </Col>
  );
};
export default UniqueToast;
